import React, {useState} from 'react'

const TodoForm = ({addTodo}) => {
  const [value, setValue] = useState("")

  const handleSubmit = e => {
    e.preventDefault(); //prevents page from reloading by default when you submit forms
    addTodo(value)

    setValue("")
  }

  return (
    <form className='TodoForm' onSubmit={handleSubmit}>
      <input type='text' className='todo-input' value={value} 
      placeholder='What is the task today?' 
      onChange={(e) => setValue(e.target.value)}/>
      <button type='select' className='todo-btn'>
        Add Task
      </button>
    </form>
  )
}

export default TodoForm